var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-filtered-select',{attrs:{"selected-key":_vm.selectedServiceLeg ? _vm.selectedServiceLeg.value : null,"options":_vm.service_LegOptions,"invalid":_vm.invalid,"placeholder":"Service Legs"},on:{"updateDropdownValue":_vm.onUpdateValue,"close":function($event){return _vm.$emit('close')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }